import { z } from 'zod'
import { RISK_TREATMENT_PLANS } from '../types/api'

const scaleField = z.number().int().min(1).max(5)

// Drata API limits: title ≤ 191 chars, description ≤ 768 chars.
export const createRiskSchema = z.object({
  name: z.string().trim().min(1, 'Risk name is required').max(191, 'Risk name must be 191 characters or fewer'),
  impact: scaleField,
  likelihood: scaleField,
  residualImpact: scaleField,
  residualLikelihood: scaleField,
  description: z.string().trim().max(768, 'Description must be 768 characters or fewer').optional(),
  categories: z.array(z.string().trim().min(1)).optional(),
  treatmentPlan: z.enum(RISK_TREATMENT_PLANS).optional(),
  treatmentDetails: z.string().trim().optional(),
  controls: z.array(z.string().trim().min(1)).optional(),
})

export type CreateRiskInput = z.infer<typeof createRiskSchema>

export const updateRiskSchema = createRiskSchema.partial()

export type UpdateRiskInput = z.infer<typeof updateRiskSchema>

export const bulkUploadRisksToClientsSchema = z.object({
  riskIds: z.array(z.uuid()).min(1),
  clients: z
    .array(
      z.object({
        clientId: z.uuid().optional(),
        clientName: z.string().min(1),
      })
    )
    .min(1),
})

export type BulkUploadRisksToClientsInput = z.infer<typeof bulkUploadRisksToClientsSchema>
